module.exports = __webpack_public_path__ + "img/_6.87e2c504.png";